import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckboxIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 40,
	height: 32,
	viewBox: "0 0 40 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 32,
			rx: 4,
			fill: "#76ec71"
		}),
		/* @__PURE__ */ _jsx("g", {
			clipPath: "url(#clip0_828_13345)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M27.5 7H12.5C12.1022 7 11.7206 7.15804 11.4393 7.43934C11.158 7.72064 11 8.10218 11 8.5V23.5C11 23.8978 11.158 24.2794 11.4393 24.5607C11.7206 24.842 12.1022 25 12.5 25H27.5C27.8978 25 28.2794 24.842 28.5607 24.5607C28.842 24.2794 29 23.8978 29 23.5V8.5C29 8.10218 28.842 7.72064 28.5607 7.43934C28.2794 7.15804 27.8978 7 27.5 7ZM24.6406 14.2938L19.1469 19.5438C19.0048 19.6774 18.8169 19.7512 18.6219 19.75C18.4298 19.7507 18.2449 19.6768 18.1063 19.5438L15.3594 16.9188C15.2832 16.8523 15.2212 16.7711 15.1772 16.6801C15.1332 16.589 15.1081 16.49 15.1033 16.389C15.0985 16.2881 15.1142 16.1871 15.1494 16.0924C15.1846 15.9976 15.2386 15.9109 15.3082 15.8375C15.3778 15.7642 15.4615 15.7056 15.5543 15.6654C15.647 15.6252 15.747 15.6042 15.8481 15.6036C15.9492 15.603 16.0494 15.6229 16.1426 15.662C16.2358 15.7011 16.3202 15.7587 16.3906 15.8312L18.6219 17.9594L23.6094 13.2062C23.7552 13.079 23.9446 13.0131 24.1379 13.0222C24.3312 13.0314 24.5135 13.1149 24.6467 13.2553C24.7798 13.3958 24.8535 13.5822 24.8524 13.7758C24.8513 13.9693 24.7754 14.1549 24.6406 14.2938Z",
				fill: "#0f172b"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_828_13345",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 4)"
			})
		}) })
	]
});
export default SvgCheckboxIcon;
